import React, { useState } from 'react';
import { Button, Fab, Grid, Tooltip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';

import { logout } from '../services/apis';

export const CerrarSesion = () => {
    const navigate = useNavigate();
    const [logOut, setLogOut] = useState(false);

    const handleClose = () => {
        setLogOut(false);
    };

    const cerrarSesion = async () => {
        try {
            await logout();
            localStorage.clear();
            setLogOut(false);
            navigate('/login', { replace: true });
        } catch (error) {
            console.error('Error al cerrar la sesion', error);
        }
    };

    return (
        <>
            <Tooltip title="Cerrar sesion">
                <Button variant="text" sx={{ color: 'var(--negro)', display: { xs: 'none', md: 'flex' } }} onClick={() => setLogOut(true)}>
                    <LogoutIcon />
                </Button>
            </Tooltip>

            <Grid
                container
                direction="row"
                size={{ xs: 12 }}
                sx={{
                    justifyContent: 'start',
                    alignItems: 'start',
                    zIndex: 1000,
                    position: 'fixed',
                    bottom: 50,
                    left: 5,
                }}
            >
                <Tooltip title="Cerrar sesion">
                    <Fab variant="text" color="negro" sx={{ display: { xs: 'flex', md: 'none' } }} onClick={() => setLogOut(true)}>
                        <LogoutIcon />
                    </Fab>
                </Tooltip>
            </Grid>

            <Dialog
                open={logOut}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="sm"
            >
                <div className="fondo-blanco">
                    <DialogTitle id="alert-dialog-title">
                        <Typography variant="h4" style={{ textAlign: 'left' }}>
                            <LogoutIcon color="primary" sx={{ fontSize: 55, mb: -1.8 }} /> Cerrar sesion
                        </Typography>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Typography variant="body1" style={{ textAlign: 'left' }}>
                                Desea cerrar la sesion?
                            </Typography>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            color="primary"
                            fullWidth
                            sx={{ m: 1 }}
                            size="large"
                            variant="contained"
                            onClick={handleClose}
                            autoFocus
                        >
                            Cancelar
                        </Button>
                        <Button
                            color="negro"
                            fullWidth
                            sx={{ m: 1 }}
                            size="large"
                            variant="outlined"
                            onClick={cerrarSesion}
                        >
                            Aceptar
                        </Button>
                    </DialogActions>
                </div>
            </Dialog>
        </>
    );
};
